// Module
var code = "<select ng-model=\"vm.model\" class=\"b-styledSelect\"> <option value=\"0\"> {{'unit.popup.unitdeallead.payment.select.no' | translate}} </option> <option value=\"1\"> {{'unit.popup.unitdeallead.payment.select.yes' | translate}} </option> </select> ";
// Exports
module.exports = code;